import { formConstants } from '../../../../utils/constants/form-constants';
import { isEmpty } from '../../../../utils/obj-utils';
import { formMessageConstants } from '../../../../utils/constants/form-message-constants';
import { createDateFromExisting } from '../../../../utils/date-utils';
import { MembershipTypes } from '../../../../../../../general/js/utils';
import userService from '../../../../../../../general/js/user/user-service';

const TheOneClubFormData = (accountFormData, userAccountData) => {
    function buildTheOneClubFormData() {
        const {
            ssoUserDetailsFields,
            ssoTheOneClubFields,
            updateUserDetailsCallbackUrl,
        } = accountFormData;

        const {
            formTitle,
            introText,
            joinTheOneClubActionSuccessText,
            leaveTheOneClubActionSuccessText,
            updateDetailsActionSuccessText,
            theOneClubImageSource,
            theOneClubImageText,
            theOneClubVideoText,
            theOneClubVideoWebmSource,
            theOneClubThumbnailSource,
            theOneClubVideoSource,
            theOneClubMotivationTitle,
            theOneClubMotivationImageSource,
            theOneClubReasons,
            theOneClubFAQTitle,
            theOneClubFAQs,
            oneClubTermsAndServices,
            leaveTheOneClubDialogBoxTitle,
            leaveTheOneClubDialogBoxMessage,
            leaveTheOneClubDialogBoxAgreeButton,
            leaveOneClubDialogBoxCheckText,
            dotDigitalAddressBookData,
            saveUserToDotDigitalCallbackUrl
        } = ssoTheOneClubFields;

        const formData = {};

        formData[formConstants.formTitle] = formTitle;
        formData[formConstants.introText] = introText;
        formData[formConstants.callBackUrl] = updateUserDetailsCallbackUrl;
        formData[formConstants.joinTheOneClubActionSuccessText] = joinTheOneClubActionSuccessText;
        formData[formConstants.leaveTheOneClubActionSuccessText] = leaveTheOneClubActionSuccessText;
        formData[formConstants.updateDetailsActionSuccessText] = updateDetailsActionSuccessText;
        formData[formConstants.theOneClubImageSource] = theOneClubImageSource;
        formData[formConstants.theOneClubImageText] = theOneClubImageText;
        formData[formConstants.theOneClubVideoText] = theOneClubVideoText;
        formData[formConstants.theOneClubThumbnailSource] = theOneClubThumbnailSource;
        formData[formConstants.theOneClubVideoWebmSource] = theOneClubVideoWebmSource;
        formData[formConstants.theOneClubVideoSource] = theOneClubVideoSource;
        formData[formConstants.theOneClubMotivationTitle] = theOneClubMotivationTitle;
        formData[formConstants.theOneClubMotivationImageSource] = theOneClubMotivationImageSource;
        formData[formConstants.theOneClubReasons] = theOneClubReasons;
        formData[formConstants.theOneClubFAQTitle] = theOneClubFAQTitle;
        formData[formConstants.theOneClubFAQs] = theOneClubFAQs;
        formData[formConstants.leaveTheOneClubDialogBoxAgreeButton] = leaveTheOneClubDialogBoxAgreeButton;
        formData[formConstants.leaveOneClubDialogBoxCheckText] = leaveOneClubDialogBoxCheckText;
        formData[formConstants.leaveTheOneClubDialogBoxMessage] = leaveTheOneClubDialogBoxMessage;
        formData[formConstants.leaveTheOneClubDialogBoxTitle] = leaveTheOneClubDialogBoxTitle;
        formData[formConstants.dotDigitalAddressBookData] = dotDigitalAddressBookData;
        formData[formConstants.saveUserToDotDigitalCallbackUrl] = saveUserToDotDigitalCallbackUrl;

        formData[formConstants.becomeOneClubMember] = ssoUserDetailsFields[formConstants.becomeOneClubMember];
        formData[formConstants.joinTheOneClubInputLabelText] = ssoUserDetailsFields[formConstants.joinTheOneClubInputLabelText];
        formData[formConstants.title] = ssoUserDetailsFields[formConstants.title];
        formData[formConstants.dateOfBirth] = ssoUserDetailsFields[formConstants.dateOfBirth];
        formData[formConstants.country] = ssoUserDetailsFields[formConstants.country];
        formData[formConstants.county] = ssoUserDetailsFields[formConstants.county];
        formData[formConstants.state] = ssoUserDetailsFields[formConstants.state];
        formData[formConstants.postcode] = ssoUserDetailsFields[formConstants.postcode];
        formData[formConstants.favoritePlayer] = ssoUserDetailsFields[formConstants.favoritePlayer];
        formData[formConstants.venues] = ssoUserDetailsFields[formConstants.venues];
        formData[formConstants.oneClubTermsAndServices] = oneClubTermsAndServices;

        return getFieldsWithDefaultValues(formData);
    }

    function getFieldsWithDefaultValues(formData) {
        const { membership } = userAccountData;
        const hasTicketingAccount = userService.hasTicketingAccount(userAccountData);
        const hasOneClubAccount = membership.includes(MembershipTypes.OneClub);
        formData[formConstants.becomeOneClubMember].defaultValue = hasOneClubAccount;
        formData[formConstants.becomeOneClubMember].fieldHeaderTitle = formMessageConstants.emptyString;
        formData[formConstants.becomeOneClubMember].fieldHeaderText = formMessageConstants.emptyString;
        formData[formConstants.hasTicketingAccount] = hasTicketingAccount;
        formData[formConstants.hasOneClubAccount] = hasOneClubAccount;
        formData[formConstants.membership] = membership;
        formData[formConstants.activeMemberships] = membership.split(';');

        formData[formConstants.title].defaultValue = userAccountData[formConstants.title];
        formData[formConstants.title].fieldHeaderTitle = formMessageConstants.emptyString;
        formData[formConstants.title].isHidden = hasTicketingAccount;
        if (userAccountData.dateOfBirth !== undefined) {
            formData[formConstants.dateOfBirth].defaultValue = createDateFromExisting(userAccountData.dateOfBirth);
            formData[formConstants.dateOfBirth].isHidden = hasTicketingAccount;
        }

        let mainAddress = {};
        if (!isEmpty(userAccountData.addresses)) {
            const foundAddress = userAccountData.addresses.find((address) => address.main);
            mainAddress = isEmpty(foundAddress) ? {} : foundAddress;
        }

        formData[formConstants.country].defaultValue = mainAddress.country;
        formData[formConstants.country].isHidden = hasTicketingAccount;

        formData[formConstants.county].defaultValue = mainAddress.county;
        formData[formConstants.county].isHidden = hasTicketingAccount;

        formData[formConstants.state].defaultValue = mainAddress.state;
        formData[formConstants.state].isHidden = hasTicketingAccount;

        formData[formConstants.postcode].defaultValue = mainAddress.postcode;
        formData[formConstants.postcode].isHidden = hasTicketingAccount;

        const interests = userAccountData[formConstants.interests];
        formData[formConstants.favoritePlayer].defaultValue = interests.favoritePlayer;
        formData[formConstants.venues].defaultValue = interests.venues;

        const optIns = userAccountData[formConstants.optIns];

        formData[formConstants.privacyPolicy] = optIns.agreedToPrivacyPolicy;
        formData[formConstants.oneClubTermsAndServices].defaultValue = optIns.agreedToTermsAndConditions;

        return formData;
    }

    return buildTheOneClubFormData();
};

export default TheOneClubFormData;
